module.exports = require('./_shared')('native-function-to-string', Function.toString);



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/modules/_function-to-string.js